import { useLanguage } from "@/i18n/LanguageContext";

const repairItems = [
  "serviceAreas.scopeRepair1",
  "serviceAreas.scopeRepair2",
  "serviceAreas.scopeRepair3",
  "serviceAreas.scopeRepair4",
  "serviceAreas.scopeRepair5",
];

const referItems = [
  "serviceAreas.scopeRefer1",
  "serviceAreas.scopeRefer2",
  "serviceAreas.scopeRefer3",
  "serviceAreas.scopeRefer4",
  "serviceAreas.scopeRefer5",
];

export default function OurScopeSection() {
  const { t } = useLanguage();
  return (
    <section className="bg-[#fefce8] py-12 md:py-[60px]">
      <div className="max-w-[1080px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-[28px] font-black text-secondary mb-3">
            {t("serviceAreas.scopeH2")}
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-10">
          <div className="bg-white rounded-xl border border-stone-100 p-6 md:p-8 shadow-sm">
            <h3 className="text-lg md:text-xl font-bold text-primary mb-4">
              <span className="w-6 h-6 inline-flex items-center justify-center mr-2">
                <i className="ri-check-line text-primary" />
              </span>
              {t("serviceAreas.scopeRepairH3")}
            </h3>
            <ul className="space-y-3">
              {repairItems.map((key) => (
                <li key={key} className="flex items-start gap-3 text-sm md:text-base text-[#374151]">
                  <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-check-line text-primary" />
                  </span>
                  {t(key)}
                </li>
              ))}
            </ul>
          </div>

          <div className="bg-white rounded-xl border border-stone-100 p-6 md:p-8 shadow-sm">
            <h3 className="text-lg md:text-xl font-bold text-accent mb-4">
              <span className="w-6 h-6 inline-flex items-center justify-center mr-2">
                <i className="ri-arrow-right-line text-accent" />
              </span>
              {t("serviceAreas.scopeReferH3")}
            </h3>
            <ul className="space-y-3">
              {referItems.map((key) => (
                <li key={key} className="flex items-start gap-3 text-sm md:text-base text-[#374151]">
                  <span className="w-5 h-5 flex items-center justify-center shrink-0 mt-0.5">
                    <i className="ri-arrow-right-line text-accent" />
                  </span>
                  {t(key)}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}